import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { categoryBadgeClass, categoryLabel } from "@/lib/categories";
import { MapPin, ImageOff, Sparkles, Briefcase } from "lucide-react";

export default function AdCard({ ad }) {
  const firstImage = ad.images?.[0];
  const isFeatured = ad.is_featured && ad.featured_until && new Date(ad.featured_until) > new Date();
  const isEmpresa = ad.owner_account_type === "empresa";
  return (
    <Link
      to={`/anuncio/${ad.id}`}
      data-testid={`ad-card-${ad.id}`}
      className={`card-elevate group flex flex-col bg-white border ${
        isFeatured ? "border-[#3B5FB8]" : "border-[#E2E8F0]"
      } relative`}
    >
      {isFeatured && (
        <div
          data-testid="featured-badge"
          className="absolute top-3 right-3 z-10 flex items-center gap-1 bg-gradient-to-r from-[#3B5FB8] to-[#1E3A8A] text-[#F8FAFC] px-2 py-1 text-[10px] font-mono uppercase tracking-widest"
        >
          <Sparkles className="w-3 h-3" /> Destacado
        </div>
      )}
      <div className="relative aspect-[4/3] bg-[#EEF2F7] overflow-hidden">
        {firstImage ? (
          <img
            src={fileUrl(firstImage)}
            alt={ad.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#64748B]">
            <ImageOff className="w-8 h-8" />
          </div>
        )}
        <div className="absolute top-3 left-3">
          <span
            className={`inline-block px-2.5 py-1 text-[10px] font-mono uppercase tracking-[0.14em] border ${categoryBadgeClass(
              ad.category,
            )}`}
          >
            {categoryLabel(ad.category)}
          </span>
        </div>
      </div>
      <div className="p-5 flex-1 flex flex-col gap-2">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-serif text-lg text-[#1A1A1A] font-semibold leading-snug line-clamp-2 flex-1">
            {ad.title}
          </h3>
          {isEmpresa && (
            <span className="inline-flex items-center gap-1 text-[9px] font-mono uppercase tracking-widest text-[#3B5FB8] border border-[#CBD5E1] px-1.5 py-0.5 flex-shrink-0" data-testid="empresa-badge">
              <Briefcase className="w-2.5 h-2.5" /> Empresa
            </span>
          )}
        </div>
        <div className="flex items-center gap-1.5 text-[13px] text-[#475569]">
          <MapPin className="w-3.5 h-3.5 text-[#3B5FB8]" />
          <span className="truncate">
            {ad.city}
            {ad.country ? `, ${ad.country}` : ""}
          </span>
        </div>
        <div className="mt-auto pt-3 flex items-baseline justify-between border-t border-[#EEF2F7]">
          <span className="font-serif text-xl font-semibold text-[#1A1A1A]">{ad.price}</span>
          <span className="text-[11px] font-mono uppercase tracking-wider text-[#3B5FB8]">Ver anuncio →</span>
        </div>
      </div>
    </Link>
  );
}
